// :cow: Cosmose CONFIDENTIAL :iso:
import { EnvironmentConfig } from '@coa/app/core/config/environmentConfig';

export const config: EnvironmentConfig = {
  'production': true,
  'apiRoot': 'https://api.cosmose.co/uaa',
  'analyticsApi': 'https://api.jp.cosmose.co/offline-analytics-api/v1',
  'clientServiceApi': 'https://api.cosmose.co/client-service/v1',
  'apiKey': 'YW5hbHl0aWNzLXdlYjplayVIMzM0NCNFZkl6cWR0',
  'prefix': 'Bearer',
  'accessToken': 'coa_access_token',
  'refreshToken': 'coa_refresh_token',
  'smartLookIntegration': true,
  'enterpriseApi': 'https://api.eu.cosmose.co/enterprise-api/v1',
  'enabledCountryIds': [8, 11],
};
